import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExpedicionEstadoService {

  constructor() { }

  /**
   * Determina si una expedición ya pasó
   */
  isPasado(expedicion: any, fechaObj: any): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const fechaBusqueda = new Date(fechaObj.toDate());
    fechaBusqueda.setHours(0, 0, 0, 0);

    // Si la fecha es anterior a hoy, siempre es pasado
    if (fechaBusqueda < today) {
      return true;
    }

    // Si no es hoy, no es pasado (es futuro)
    if (!this.isHoy(fechaObj)) {
      return false;
    }

    // Si es hoy y tiene planning, usar PLA_HRET
    if (expedicion.planning?.PLA_HRET) {
      const [hours, minutes] = expedicion.planning.PLA_HRET.split(':').map(Number);
      const llegadaTime = new Date(fechaObj.toDate());
      llegadaTime.setHours(hours, minutes, 0, 0);
      return llegadaTime < new Date();
    }

    // Fallback: usar horario de salida
    const horario = expedicion.parada_expediciones[0].horario; // "17:30"
    const [hours, minutes] = horario.split(':').map(Number);

    const expedicionDate = new Date(fechaObj.toDate());
    expedicionDate.setHours(hours, minutes, 0, 0);

    return expedicionDate < new Date();
  }

  /**
   * Determina si una expedición está en curso
   */
  isEnCurso(expedicion: any, fechaObj: any): boolean {
    // Solo puede estar en curso si es hoy
    if (!this.isHoy(fechaObj)) {
      return false;
    }

    // Solo si tiene planning
    if (!expedicion.planning?.PLA_HDEP || !expedicion.planning?.PLA_HRET) {
      return false;
    }

    const [salidaHours, salidaMinutes] = expedicion.planning.PLA_HDEP.split(':').map(Number);
    const [llegadaHours, llegadaMinutes] = expedicion.planning.PLA_HRET.split(':').map(Number);

    const salidaTime = new Date(fechaObj.toDate());
    salidaTime.setHours(salidaHours, salidaMinutes, 0, 0);

    const llegadaTime = new Date(fechaObj.toDate());
    llegadaTime.setHours(llegadaHours, llegadaMinutes, 0, 0);

    const now = new Date();
    return now >= salidaTime && now <= llegadaTime;
  }

  /**
   * Determina si la fecha de búsqueda es hoy
   */
  isHoy(fechaObj: any): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const fechaBusqueda = new Date(fechaObj.toDate());
    fechaBusqueda.setHours(0, 0, 0, 0);

    return fechaBusqueda.getTime() === today.getTime();
  }

  /**
   * Encuentra la mejor expedición para hacer scroll automático
   * Prioridad: 1) En curso, 2) Futura, 3) Última pasada
   */
  findBestExpedicionToScroll(expediciones: any[], fechaObj: any): any {
    if (!expediciones || expediciones.length === 0) {
      return null;
    }

    // 1. Buscar primera expedición en curso
    let enCurso = expediciones.find(expedicion => {
      return this.isEnCurso(expedicion, fechaObj);
    });
    if (enCurso) {
      return enCurso;
    }

    // 2. Buscar primera expedición futura
    let futura = expediciones.find(expedicion => {
      return !this.isPasado(expedicion, fechaObj);
    });
    if (futura) {
      return futura;
    }

    // 3. Fallback: última expedición pasada
    let expedicionesPasadas = expediciones.filter(expedicion => {
      return this.isPasado(expedicion, fechaObj);
    });
    if (expedicionesPasadas.length > 0) {
      return expedicionesPasadas[expedicionesPasadas.length - 1];
    }

    return null;
  }
}